import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { ActivityModelNew } from "../models/newChanges";

@Injectable()
export class CommonActivityService {
  commonActivityMap: any;
  commPillarHasToReload: any = {
    packaging: false,
    deforestation: false
  };
  constructor(private readonly http: HttpClient) {
    this.getcommonActivityMap().subscribe(res => {
      this.commonActivityMap = res;
    });
  }

  getOtherCommPillar(activity, pillarName) {
    let anotherPillar = "";
    const commPillars = activity.questionList[0]["commonActivity"].commonPillars;
    commPillars.forEach(obj => {
      if (obj.name !== pillarName) {
        anotherPillar = obj.name;
      }
    });

    return anotherPillar;
  }

  updateCommonActivityStatus(
    activity: ActivityModelNew,
    pillarName,
    pillarId,
    refPillarId,
    activityForm,
    hasAnswer
  ): void {
    if (activity.commonActivity && this.commonActivityMap[activity.id]) {
      const commAct = this.commonActivityMap[activity.id];
      commAct[pillarName].hasAnswer = hasAnswer;
      const otherPillar = this.getOtherCommPillar(activity, pillarName);

      if (refPillarId !== null) {
        if (refPillarId === pillarId) {
          commAct[pillarName].hasAllowToAnswer = true;
          commAct[otherPillar].hasAnswer = hasAnswer;
          commAct[otherPillar].hasAllowToAnswer = false;
        } else {
          activity.toggleFlag = false;
          activityForm.get("toggleFlagCtl").setValue(false);
          commAct[pillarName].hasAllowToAnswer = false;

          commAct[otherPillar].hasAllowToAnswer = true;
        }
      }
    }
  }
  private getcommonActivityMap() {
    const path = "assets/common-activity.json";
    return this.http.get(path);
  }

 }


